export const geocodingOptions = {
    method: 'GET',
    headers: {
            'X-RapidAPI-Key': '2e3b50362dmsha4aac98910db273p1e018ejsnda72ae9c4259',
            'X-RapidAPI-Host': 'trueway-geocoding.p.rapidapi.com'
    },
};
